import React, { /*Component*/ useState, useEffect } from 'react';
import { getApplication, retrieveQuoteFromToken, startApplication, retrieveResourceFromToken} from '../api/applicationAPI';
import { navigateWithData, navigate } from '../navigation/navigationHistory';
import { env, deleteParam } from '../env';
import {resetSessionLinkIds} from "../api";

export function RetrieveTokenQuote(props) {

    const { errorMsgToken, errorMsgPostalCode, pleaseWaitMsg } = props;
    const { token, postalCode, newQuote, editInd, carrierGroupId: carrierGroupCd, licenseClass: licenseClassCd, effectiveDate } = env;  // The env structure captures all URL query parameters
    const [errorMessage, setErrorMessage] = useState();
    let { carrierGroupId, licenseClass} = props;
    const carrierGrp = carrierGroupCd ? carrierGroupCd : carrierGroupId;
    const licenseCls = licenseClassCd ? licenseClassCd : licenseClass;


    function isTrue(value) {
        const falses = [ 'no', 'false', 'off', '0' ];
        let result = false;

        if (value) {
            // If there is a value for the property, treat it as 'true'
            result = true;
            // If the property's value matches a 'no' word, treat it as 'false'
            if (falses.includes(value)) result = false;
        }

        return (result);
    }

    function handleQuoteFromToken(tokenParam) {
        const request = { clientId: 'ServicePortal', resourceToken: tokenParam };

        if (isTrue(newQuote)) {
            // Pass on the token directly to the new quote creation to determine the customer
            startApplication({carrierGroupId: carrierGrp, postalCode: postalCode, licenseClass: licenseCls, customerRef: tokenParam, effectiveDate: effectiveDate}).then((systemId) => {
                // NOTE: see INC-36836 about moving deleteParam()
                deleteParam('token');  // this value is no longer needed
                navigate(`/application/${systemId}`, true);
            });
        } else {
            // Map the token to a system ID, read the quote data, and redirect to summary
            retrieveQuoteFromToken(request).then((systemId) => {
                deleteParam('token');  // this value is no longer needed
                if (isTrue(editInd)) {
                    navigate(`/application/${systemId}`, true);
                } else {
                    getApplication(systemId).then((app) => {
                        navigateWithData('/quote-summary', app, true);
                    })
                    .catch((err) => {
                        console.log(`Cannot retrieve quote for ${systemId}: ${err}`);
                        return setErrorMessage(errorMsgToken);
                    });
                }
            })
            .catch((err2) => {
                console.log(`Cannot resolve token for ${token}: ${err2}`);
                return setErrorMessage(errorMsgToken);
            });
        }

    }

    function handleQuoteForPostalCode(postalCode) {
        // Start a new application using the indicated zip code (if possible)
        startApplication({carrierGroupId: carrierGrp, postalCode: postalCode, licenseClass: licenseCls, effectiveDate: effectiveDate}).then((systemId) => {
            navigate(`/application/${systemId}`);
        })
        .catch((err) => {
            console.log(`Cannot start new application for ${postalCode}: ${err}`);
            return setErrorMessage(errorMsgPostalCode);
        });
    }

    resetSessionLinkIds(true);
    if (token) {
        // Retrieve an already-created quote from the given token and navigate to it
        handleQuoteFromToken(token);
    } else {
        // Start a new quote using the postal-code that was given
        handleQuoteForPostalCode(postalCode);
    }

    return (
        <div>
            <p>{errorMessage ? errorMessage : pleaseWaitMsg}</p>
        </div>
    );
}
 
